export enum TextPlacement {
    Left = 'left',
    Right = 'right',
}
